import { lazy, useCallback } from 'react';

import { useAppTranslation } from 'hooks/use-translates';

import styles from '@login/pages/friends-and-family/friends-and-family.module.scss';

const FormBox = lazy(() => import('@login/components/form-box/form-box'));
const FormHeader = lazy(() => import('@login/components/form-header/form-header'));
const ButtonsToggler = lazy(() => import('@login/components/buttons-toggler/buttons-toggler'));

type FriendsAndFamilyProps = {
    onChange: (value: boolean) => void;
};

export const FriendsAndFamily = ({ onChange }: FriendsAndFamilyProps) => {
    const { t } = useAppTranslation();

	const handleChange = useCallback(
		(value: boolean | undefined) => {
			onChange(value ?? false);
		},
		[onChange]
	);

	return (
		<FormBox>
			<FormHeader headerTitle={t('common.friends_and_family_tab')} />

			<div className={styles['content-wrapper']}>
				<p className="body-medium bold">
					{t('friends_and_family.redirect_label')}
				</p>

				<ButtonsToggler
					id="optIn"
					trueLabel={t('register.yes_label')}
					falseLabel={t('register.no_label')}
					value={undefined}
					errorMessage=""
					errorIcon="AlertCircleFilled"
					onChange={(value) => handleChange(value)}
				/>
			</div>
		</FormBox>
	);
};

export default FriendsAndFamily;
